import { createApp } from '@backstage/frontend-defaults';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { sandboxModule } from './modules/sandbox';
import { catalogModule } from './modules/catalog';
import { accessModule } from './modules/access';
import { platformModule } from './modules/platform';
import { thirdPartyModule } from './modules/thirdParty';
import { shellModule } from './modules/shell';
import { SignInPage } from './modules/auth/SignInPage';

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props => <SignInPage {...props} />,
  },
});

const authModule = createFrontendModule({
  pluginId: 'app',
  extensions: [signInPage],
});

export default createApp({
  features: [authModule, shellModule, sandboxModule, catalogModule, accessModule, platformModule, thirdPartyModule],
});
